

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface InstructionParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Instruction { 
    id?: any;
    tenantId: any;
    branchId: any;
    code: string;
    name:string;
    isActive:Boolean;
    departmentList?: any;
    mappingAttribute?:string;
    
  parameters?: InstructionParameter[];
  links?: any;
}

export abstract class InstructionData { 
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<Instruction[]>;
  abstract create(url: string, data: Instruction): Observable<Instruction[]>;
  abstract update(url: string, data: Instruction): Observable<Instruction>;
  abstract delete(url: string): Observable<any>;
 
  
}
